/**
 * Backend API base URL for Discord OAuth and role management.
 * Set REACT_APP_API_URL in .env (e.g. http://localhost:3001 in dev).
 */
export const API_URL = process.env.REACT_APP_API_URL || '';

export function getDiscordLoginUrl() {
  return `${API_URL}/api/auth/discord`;
}

export async function updateDiscordRoles({ discordId, department, action }) {
  const res = await fetch(`${API_URL}/api/discord/roles`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ discordId, department, action }),
  });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.error || `Failed to update roles (${res.status})`);
  }
  return res.json();
}
